import { useEffect, useRef } from "react";
import "./MultiPurpose.css";
import { useNavigate } from "react-router-dom";
import { CircleCheck, X } from "lucide-react";

const MultiPurpose = ({
  title = "Notice",
  message = "",
  yesText = "YES",
  noText = "NO",
  onYes,
  onNo,
  showYesLink = false,
  yesLink = "",
  showNoLink = false,
  noLink = "",
  onClose,
  hideNo = false,
  useHTML = false,
  variant = "",
  children,
  className = "",
}) => {
  const navigate = useNavigate();
  const modalRef = useRef(null);

  const isSuccess = variant === "success";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        if (onClose) {
          onClose();
        } else if (yesLink) {
          if (yesLink.startsWith("http://") || yesLink.startsWith("https://")) {
            window.location.href = yesLink;
          } else {
            navigate(yesLink);
          }
        }
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="multipurpose_v2">
      <div className="multipurpose-content_v2" ref={modalRef}>
        <div className={`multipurpose-title-container_v2 ${className}`}>
          <div className="multipurpose-title_v2">
            <strong>{title}</strong>
          </div>
          <button
            className="mp-close-button_v2"
            onClick={() => {
              if (onClose) {
                onClose();
                return;
              }
              if (onNo) onNo();
              const target = noLink || yesLink || "/allorder";
              if (
                target.startsWith("http://") ||
                target.startsWith("https://")
              ) {
                window.location.href = target;
              } else {
                navigate(target);
              }
            }}
          >
            <X />
          </button>
        </div>

        {isSuccess && (
          <div className="mp-success-icon_v2">
            <div className={`mp-success-badge_v2 ${className}`}>
              <CircleCheck size={32} />
            </div>
          </div>
        )}

        <div
          className="multipurpose-main_v2"
          style={isSuccess ? { paddingTop: "16px" } : undefined}
        >
          {children ? (
            children
          ) : useHTML ? (
            <div dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            message
          )}
        </div>

        <div className="multipurpose-sub_v2">
          {showNoLink ? (
            <button
              className="multipurpose-no_v2"
              onClick={() => {
                if (onNo) onNo();
                if (onClose) {
                  onClose();
                  return;
                }
                const target = noLink || yesLink || "/allorder";
                if (
                  target.startsWith("http://") ||
                  target.startsWith("https://")
                ) {
                  window.location.href = target;
                } else {
                  navigate(target);
                }
              }}
            >
              {noText}
            </button>
          ) : (
            !hideNo && (
              <button className="multipurpose-no_v2" onClick={onNo}>
                {noText}
              </button>
            )
          )}
          {showYesLink ? (
            <button
              className={`multipurpose-yes_v2 ${className}`}
              onClick={() => {
                if (onYes) onYes();
                if (onClose) {
                  onClose();
                  return;
                }
                const target = yesLink || noLink || "/allorder";
                if (
                  target.startsWith("http://") ||
                  target.startsWith("https://")
                ) {
                  window.location.href = target;
                } else {
                  navigate(target);
                }
              }}
            >
              {yesText}
            </button>
          ) : (
            <button
              className={`multipurpose-yes_v2 ${className}`}
              onClick={onYes}
            >
              {yesText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiPurpose;
